import React, { createContext, useContext, useState, useMemo } from 'react';
import type { Artwork } from '../types';

export type FeedCacheState = {
  posts: Artwork[];
  setPosts: React.Dispatch<React.SetStateAction<Artwork[]>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  reposts: Artwork[];
  setReposts: React.Dispatch<React.SetStateAction<Artwork[]>>;
};

const FeedCacheContext = createContext<FeedCacheState | undefined>(undefined);

export const FeedCacheProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [posts, setPosts] = useState<Artwork[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [reposts, setReposts] = useState<Artwork[]>([]);

  const value = useMemo(() => ({ posts, setPosts, loading, setLoading, reposts, setReposts }), [posts, loading, reposts]);
  return <FeedCacheContext.Provider value={value}>{children}</FeedCacheContext.Provider>;
};

export function useFeedCache(): FeedCacheState {
  const ctx = useContext(FeedCacheContext);
  if (!ctx) throw new Error('useFeedCache must be used within FeedCacheProvider');
  return ctx;
}
